import React, {Component} from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import { DashboardLayout } from '../../layout';
import { DocumentTitle } from '../../../helpers';
import TutorProfileMenu from './partials/TutorProfileMenu';
import { UpdatePassword } from '../Common';

class TutorChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (<DashboardLayout activeClass="UserSetting">
            <DocumentTitle title={`Change Password`}/>
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Account Setting</h2>
                        </div>
                    </div>
                    <TutorProfileMenu />
                    <div className="col-md-9">
                        <div className="post-box p-0">
                            <div className="heading">
                            Change Password
                            </div>
                            <div className="row">                                        
                                <div className="col-md-6">
                                    <div className="setting-form">    
                                        <UpdatePassword />
                                    </div>
                                </div>
                            </div>        
                        </div>
                    </div>
                </div>
            </section> 
        </DashboardLayout>);
    }
}
const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);
export default connect(mapStateToProps)(TutorChangePassword);

